import React, { useEffect, useState } from 'react';
import Header2 from '../header/Header2';
import Footer from '../footer/Footer';
import { MdOutlineNearbyError } from "react-icons/md";
import { IoReload } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const [clickToAnimate, setClickToAnimate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!clickToAnimate) return undefined;

    const timer = setTimeout(() => {
      navigate("/");
    }, 1200);

    return () => clearTimeout(timer);
  }, [clickToAnimate, navigate]);

  return (
    <div className='mk-page mk-state-page min-h-screen bg-[#f7f8fc] flex flex-col'>
      <div className='w-full md:hidden'>
        <Header2 />
      </div>

      <main className='flex flex-1 items-center justify-center px-4'>
        <div className='w-full max-w-[520px] rounded-[18px] border border-slate-200 bg-white p-8 text-center shadow-[0_8px_30px_rgba(24,31,65,0.06)]'>
          <MdOutlineNearbyError className='mx-auto text-[46px] text-[#4F48EC]' />
          <p className='mt-4 text-[22px] font-semibold text-slate-900'>اطلاعات موردنظر پیدا نشد</p>
          <p className='mt-2 text-[14px] leading-7 text-slate-500'>ممکن است سفر تغییر کرده باشد یا ارتباط با سرور کامل نشده باشد.</p>
          <button
            type='button'
            disabled={clickToAnimate}
            onClick={() => setClickToAnimate(true)}
            className='mx-auto mt-6 flex h-[46px] min-w-[190px] items-center justify-center gap-2 rounded-[10px] border border-[#4F48EC] px-5 text-[#4F48EC]'
          >
            <span>{clickToAnimate ? "در حال بازگشت..." : "بازگشت به صفحه اصلی"}</span>
            <IoReload className={clickToAnimate ? "animate-spin" : ""} />
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;